export default {
  nav: {
    brandProducts: 'Positive-Produkte', discover: 'Entdecken', allProducts: 'Alle Produkte',
    otherProducts: 'Weitere Produkte: {count}',
    connectedApps: 'Verbundene Apps', currentProduct: 'Sie befinden sich in {product}',
    openApp: '{product} in einem neuen Tab öffnen', discoverProduct: '{product} entdecken',
  },
  actions: {
    tryFree: 'Kostenlos testen', discover: 'Entdecken', discoverProduct: '{product} entdecken',
    backToCatalog: 'Zurück zu allen Produkten',
    signIn: 'Anmelden', close: 'Schließen',
  },
  agent: {
    useAssistant: 'In Ihrem KI-Assistenten nutzen', title: '{product} in Ihrem KI-Assistenten nutzen',
    description: 'Verbinden Sie Ihren Assistenten über den MCP-Server mit {product}.',
    other: 'Andere',
    copyPrompt: 'Prompt kopieren',
    copyDone: 'Kopiert', copyRetry: 'Erneut',
    connectTitle: 'Assistenten auswählen', connect: 'Verbinden', availableFor: 'Für {product} verfügbar',
    connectionHint: 'Möglicherweise müssen Sie sich anmelden und den Zugriff genehmigen.',
    permissions: 'Ihr Assistent kann nur auf Daten und Aktionen zugreifen, die Sie autorisieren.',
    copy: 'Einrichtungsprompt für die Verbindung Ihres Agenten mit {product} kopieren',
    copied: 'Prompt kopiert. Fügen Sie ihn in Ihren Agenten ein.', copyError: 'Der Prompt konnte nicht kopiert werden. Bitte versuchen Sie es erneut.',
  },
  catalog: {
    title: 'Positive-Produkte entdecken', description: 'Tools, die {product} ergänzen.',
    descriptionDefault: 'Tools für Ihre Marketing- und Vertriebsteams.', empty: 'Keine Produkte zum Entdecken.',
  },
  product: { featuresTitle: 'Was Sie mit {product} tun können' },
  status: { current: 'Aktuelle App', connected: 'Verbundene App' },
  accessibility: { openMenu: 'Produktnavigation öffnen', newTab: 'Öffnet sich in einem neuen Tab' },
  categories: { emailSignatures: 'E-Mail-Signaturen', emailing: 'E-Mail-Marketing', seo: 'SEO & GEO', socialMedia: 'Social Media', sales: 'Vertrieb' },
  products: {
    signitic: {
      tagline: 'Verwaltung von E-Mail-Signaturen',
      description: 'Verwalten Sie alle E-Mail-Signaturen zentral und machen Sie sie zu einem Marketingkanal.',
      features: ['Einheitliche Signaturen im ganzen Unternehmen', 'Bannerkampagnen in jeder E-Mail', 'Analysen zu Klicks und Reichweite'],
    },
    user: {
      tagline: 'E-Mail-Marketing und Kundenbindung',
      description: 'Automatisierung, CRM und Live-Chat, um Ihre Kontakte im richtigen Moment anzusprechen.',
      features: ['Automatisierte E-Mail- und SMS-Strecken', 'CRM für Kontakte und Verkaufschancen', 'Live-Chat auf Ihrer Website'],
    },
    surfer: {
      tagline: 'Content-Optimierung für SEO und GEO',
      description: 'Schreiben Sie Inhalte, die bei Google gut ranken und von KI-Assistenten zitiert werden.',
      features: ['Content-Briefings für bessere Google-Rankings', 'Zitate in ChatGPT und KI-Antworten', 'KI-gestützte Artikelerstellung'],
    },
    iconosquare: {
      tagline: 'Social-Media-Verwaltung und -Analyse',
      description: 'Planen Sie Beiträge, beantworten Sie Nachrichten und messen Sie die Leistung aller Netzwerke auf einer Plattform.',
      features: ['Beiträge für jedes Netzwerk planen', 'Ein Posteingang für Kommentare und Direktnachrichten', 'Analysen und Berichte'],
    },
    humanlinker: {
      tagline: 'KI-Copilot für den Vertrieb',
      description: 'Sprechen Sie jeden Interessenten individuell an und verwandeln Sie Gespräche in Umsatz.',
      features: ['KI-Empfehlungen für potenzielle Kunden', 'Personalisierte Kontaktsequenzen', 'Meeting-Vorbereitung mit einem Klick'],
    },
    ubic: {
      tagline: 'Paralleles Wählen für Vertriebsteams',
      description: 'Ein Parallel-Dialer, mit dem Vertriebsteams in weniger Zeit mehr Interessenten erreichen.',
      features: ['Mehrere Interessenten gleichzeitig anrufen', 'Nur angenommene Anrufe werden an Sie weitergeleitet', 'Synchronisierung mit Ihrem CRM'],
    },
    nocrm: {
      tagline: 'Lead-Management für Vertriebsmitarbeiter',
      description: 'Verfolgen Sie jeden Lead vom ersten Kontakt bis zum Abschluss, ohne den Aufwand eines CRM.',
      features: ['Alle Leads in einer Pipeline', 'Erinnerungen, damit keine Chance verloren geht', 'Mobile App für den Außendienst'],
    },
  },
};
